import type { ImageCarouselRefInterface, ImageChangeHandler } from 'LuxKit/Carousel/BaseImageCarousel'
import { useCallback, useRef } from 'react'

/** Show the next photo on hover, then restore the first unless the traveller navigates. */
export default function useImageCarouselHoverPreview(
  images: Array<App.Image>,
  enabled: boolean,
  onImageChange?: ImageChangeHandler,
) {
  const carouselRef = useRef<ImageCarouselRefInterface | null>(null)
  const isInHoverState = useRef(false)

  const handleImageChange = useCallback<ImageChangeHandler>((index, image) => {
    if (image && isInHoverState.current && index !== 1) {
      isInHoverState.current = false
    }
    onImageChange?.(index, image)
  }, [onImageChange])

  const handleMouseEnter = useCallback(() => {
    if (enabled && images.length > 1 && carouselRef.current?.getCurrentImageIndex() === 0) {
      isInHoverState.current = true
      carouselRef.current.goToImage(images[1], 'smooth')
    }
  }, [enabled, images])

  const handleMouseLeave = useCallback(() => {
    if (enabled && isInHoverState.current && carouselRef.current && images.length > 0) {
      carouselRef.current.goToImage(images[0], 'smooth')
    }
    isInHoverState.current = false
  }, [enabled, images])

  return { carouselRef, handleImageChange, handleMouseEnter, handleMouseLeave }
}
